module.exports = __webpack_public_path__ + "static/media/SimpleGoodOptimized.4a8ec9d9.jp2";